import {
    addEditDPActionTypes,
    addEditDPServiceActionTypes,
    addEditDPSourceActionTypes,
    addEditTypes
} from "../constants/AddEditActionConstants";
import {formatInputKeys} from "./AddEditDPServiceActions";

const createDPModal = (value) => ({
    type: addEditDPActionTypes.CREATE_DP_MODAL,
    payload: value,
});

const editDPModal = (detailObject) => ({
    type: addEditDPActionTypes.EDIT_DP_MODAL,
    payload: {detailObject},
});

const closeDPModal = () => ({
    type: addEditDPActionTypes.CLOSE_DP_MODAL,
});

const createDPServiceModal = (value) => ({
    type: addEditDPServiceActionTypes.CREATE_DP_SERVICE_MODAL,
    payload: value,
});

const editDPServiceModal = (detailObject) => ({
    type: addEditDPServiceActionTypes.EDIT_DP_SERVICE_MODAL,
    payload: {detailObject},
});

const closeDPServicesModal = () => ({
    type: addEditDPServiceActionTypes.CLOSE_DP_SERVICE_MODAL,
});

const createDPSourceModal = (value) => ({
    type: addEditDPSourceActionTypes.CREATE_DP_SOURCE_MODAL,
    payload: value,
});

const editDPSourceModal = (detailObject) => ({
    type: addEditDPSourceActionTypes.EDIT_DP_SOURCE_MODAL,
    payload: {detailObject},
});

const closeDPSourcesModal = () => ({
    type: addEditDPSourceActionTypes.CLOSE_DP_SOURCE_MODAL,
});

export function closeAddEditModal(type) {
    return (dispatch) => {
        switch (type) {
            case addEditTypes.DP:
                dispatch(closeDPModal(type));
                return;

            case addEditTypes.DP_SERVICE:
                dispatch(closeDPServicesModal(type));
                return;

            case addEditTypes.DP_SOURCE:
                dispatch(closeDPSourcesModal(type));
                return;

            default:
                console.error("Wrong action dispatched.")
                return;
        }
    }
}

export function addNewDP(value) {
    return (dispatch) => {
        switch (value) {
            case addEditTypes.DP:
                dispatch(createDPModal(value));
                return;

            case addEditTypes.DP_SERVICE:
                dispatch(createDPServiceModal(value));
                dispatch(formatInputKeys())
                return;

            case addEditTypes.DP_SOURCE:
                dispatch(createDPSourceModal(value));
                return;

            default:
                console.error("Wrong action dispatched.")
                return;
        }
    }
}

export function openEditModal(type, detailObject) {
    return (dispatch) => {
        switch (type) {

            case addEditTypes.DP:
                dispatch(editDPModal(detailObject));
                return;

            case addEditTypes.DP_SERVICE:
                dispatch(editDPServiceModal(detailObject));
                dispatch(formatInputKeys())
                return;

            case addEditTypes.DP_SOURCE:
                dispatch(editDPSourceModal(detailObject));
                return;

            default:
                console.error("Wrong Action Dispatched.");
                return;
        }
    }
}
